import { LANGS } from "./i18n";

/* Which guides exist and where they are linked from, without their text:
   main.tsx builds routes from this, and the footer and product pages link
   from it, so none of them pull the guides themselves into the first load. */

export const GUIDE_LINKS = [
  { path: "/deadlock-cheats", label: "Deadlock cheats guide" },
  { path: "/deadlock-aimbot", label: "Deadlock aimbot guide" },
  { path: "/deadlock-esp-wallhack", label: "Deadlock ESP & wallhack guide" },
  { path: "/deadlock-hero-scripts", label: "Deadlock hero scripts" },
  { path: "/free-deadlock-cheat", label: "Free Deadlock cheat" },
  { path: "/cs2-cheats", label: "CS2 cheats guide" },
  { path: "/fivem-cheats", label: "FiveM cheats guide" },
  { path: "/unknowncheats-alternative", label: "UnknownCheats alternative" },
] as const;

export const GUIDE_SLUGS = GUIDE_LINKS.map((g) => g.path.slice(1));

/* The translated Deadlock pages (guides/localized.tsx): kept out of
   GUIDE_LINKS so the English footer and product pages do not list them. */
export const LOCALIZED_SLUGS = LANGS.flatMap((l) => [l, `${l}/free-deadlock-cheat`]);

const guideAt = (path: (typeof GUIDE_LINKS)[number]["path"]) => GUIDE_LINKS.find((g) => g.path === path)!;

/** The guide a product page points to, by game id. Looked up by path, not by
    position: picking by index sent the CS2 and FiveM pages to the Deadlock
    aimbot and ESP guides as soon as those were added to the list above. */
export const PRODUCT_GUIDE: Record<string, (typeof GUIDE_LINKS)[number]> = {
  "deadlock-external": guideAt("/deadlock-cheats"),
  "cs2-external": guideAt("/cs2-cheats"),
  "fivem-external": guideAt("/fivem-cheats"),
};
